// Baner nad każdym ekranem, gdy ktoś zaprasza do urządzenia (S-3) - zamiast okna starej APP, które wyskakiwało co 90 s.
// Lista przychodzi przy starcie i ze zdarzenia `udostepnienia.zmiana`; na ekranie Udostępniania (zaproszenia są na
// jego górze) baner znika.
import { useLocation, useNavigate } from "react-router";
import { t } from "../../i18n/t";
import { useZaproszenia } from "../../api/udostepnienia";
import { IkonaOsoby } from "../../uklad/ikony";
import type { BanerDane } from "../../uklad/Powloka";

export function useBaneryZaproszen(): BanerDane[] {
  const n = useZaproszenia().length;
  const { pathname } = useLocation();
  const idz = useNavigate();
  if (n === 0 || pathname === "/udostepnianie") return [];
  return [{ id: "zaproszenia", rodzaj: "nowe", ikona: IkonaOsoby,
    tresc: n === 1 ? t("Masz zaproszenie do urządzenia.") : t("Masz zaproszenia do urządzeń ({n}).", { n }),
    etykietaAkcji: t("Zobacz"), onAkcja: () => void idz("/udostepnianie") }];
}
